var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-one-toolbar-tab-layout',{attrs:{"id":"project-one-toolbar-spec","qaid":"project-one-toolbar-spec","title":_vm.bp('specsTitle'),"list":_vm.dataList}})}
var staticRenderFns = []

export { render, staticRenderFns }